import React from 'react';
import { connect } from 'react-redux';
import RangeChartContainer from 'components/pages/stats/occupancyrange/rangechartcontainer';
import { getNodeSeriesStats, getParams } from 'actions/stats';
//import Modal from "components/common/modal";
export class OccupancyRange extends React.Component {

    componentWillReceiveProps(nextProps) {
        if (nextProps.currentNode.id) {
            let params = getParams(nextProps);
            params.groupby = 'hour';
            params.chart = 'range';
            this.props.dispatch(getNodeSeriesStats(params));
        }
    }
    render() {
        return (
            <div className="stats-card">
                <div className="box--shadow bg--white card__graph" ref={(e) => { document.charts.occupancyrange = e }} >
                    <div className="clearfix graph__header">
                        <div className="graph__header__title col-sm-offset-3 col-sm-6 clearfix">
                            <h2>{this.props.querySettings.tag} Range</h2>
                        </div>
                        <div className="graph__header__options clearfix">
                            {/*<Modal
                            disableCloseButton={true}
                            ref={(elem) => { this.openInfoModal = elem }}
                            clickButton={() => { this.openInfoModal.close(); }}
                            header="Info Modal"
                            buttonText="Got it"
                            buttonClass="btn-success"
                            entry={
                                <div className="pull-right header__options__child">
                                    <div onClick={() => { this.openInfoModal.open() }}>
                                        <img className="card-info cursor--pointer" src="src/assets/icons/info.svg" alt="info-icon" />
                                    </div>
                                </div>
                            }
                        >
                            <p>Range Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
                        </Modal>*/}
                        </div>
                    </div>
                    <div className="graph__body">
                        <RangeChartContainer />
                    </div>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default connect(null, mapDispatchToProps)(OccupancyRange);


// WEBPACK FOOTER //
// ./src/components/pages/stats/occupancyrange/index.jsx